import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import config from '@plone/volto/registry';
import RenderBlocks from '@plone/volto/components/theme/View/RenderBlocks';
import {
  RODAPE_SUBREQUEST,
  buscaRodape,
} from '../../../../components/footer/rodape';
// Versão vertical da marca: o nome por extenso ocupa a largura inteira e sai
// legível numa coluna estreita (na horizontal, a 182 px, saía com ~6 px).
// Arquivo reduzido a 660 px (3x a largura exibida), paleta exata.
import logoWhite from '../../../../theme/brand/logo-branca-vertical-660.png';
import { GERENCIAR_COOKIES } from 'volto-agsus/components/CookieBanner';

const SOCIAL = [
  {
    label: 'Facebook',
    href: 'https://www.facebook.com/agenciasus',
    path: 'M9.101 23.691v-7.98H6.627v-3.667h2.474v-1.58c0-4.085 1.848-5.978 5.858-5.978.401 0 .955.042 1.468.103a8.68 8.68 0 0 1 1.141.195v3.325a8.623 8.623 0 0 0-.653-.036 26.805 26.805 0 0 0-.733-.009c-.707 0-1.259.096-1.675.309a1.686 1.686 0 0 0-.679.622c-.258.42-.374.995-.374 1.752v1.297h3.919l-.386 2.103-.287 1.564h-3.246v8.245C19.396 23.238 24 18.179 24 12.044c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.628 3.874 10.35 9.101 11.647Z',
  },
  {
    label: 'Flickr',
    href: 'https://www.flickr.com/photos/agenciasus/albums',
    circles: true,
  },
  {
    label: 'Instagram',
    href: 'https://www.instagram.com/agenciasus/',
    path: 'M12 0C8.74 0 8.333.015 7.053.072 5.775.132 4.905.333 4.14.63c-.789.306-1.459.717-2.126 1.384S.935 3.35.63 4.14C.333 4.905.131 5.775.072 7.053.012 8.333 0 8.74 0 12s.015 3.667.072 4.947c.06 1.277.261 2.148.558 2.913.306.788.717 1.459 1.384 2.126.667.666 1.336 1.079 2.126 1.384.766.296 1.636.499 2.913.558C8.333 23.988 8.74 24 12 24s3.667-.015 4.947-.072c1.277-.06 2.148-.262 2.913-.558.788-.306 1.459-.718 2.126-1.384.666-.667 1.079-1.335 1.384-2.126.296-.765.499-1.636.558-2.913.06-1.28.072-1.687.072-4.947s-.015-3.667-.072-4.947c-.06-1.277-.262-2.149-.558-2.913-.306-.789-.718-1.459-1.384-2.126C21.319 1.347 20.651.935 19.86.63c-.765-.297-1.636-.499-2.913-.558C15.667.012 15.26 0 12 0Zm0 2.16c3.203 0 3.585.016 4.85.071 1.17.055 1.805.249 2.227.415.562.217.96.477 1.382.896.419.42.679.819.896 1.381.164.422.36 1.057.413 2.227.057 1.266.07 1.646.07 4.85s-.015 3.585-.074 4.85c-.061 1.17-.256 1.805-.421 2.227-.224.562-.479.96-.899 1.382-.419.419-.824.679-1.38.896-.42.164-1.065.36-2.235.413-1.274.057-1.649.07-4.859.07-3.211 0-3.586-.015-4.859-.074-1.171-.061-1.816-.256-2.236-.421-.569-.224-.96-.479-1.379-.899-.421-.419-.69-.824-.9-1.38-.165-.42-.359-1.065-.42-2.235-.045-1.26-.061-1.649-.061-4.844 0-3.196.016-3.586.061-4.861.061-1.17.255-1.814.42-2.234.21-.57.479-.96.9-1.381.419-.419.81-.689 1.379-.898.42-.166 1.051-.361 2.221-.421 1.275-.045 1.65-.06 4.859-.06l.045.03Zm0 3.678c-3.405 0-6.162 2.76-6.162 6.162 0 3.405 2.76 6.162 6.162 6.162 3.405 0 6.162-2.76 6.162-6.162 0-3.405-2.76-6.162-6.162-6.162ZM12 16c-2.21 0-4-1.79-4-4s1.79-4 4-4 4 1.79 4 4-1.79 4-4 4Zm7.846-10.405c0 .795-.646 1.44-1.44 1.44-.795 0-1.44-.646-1.44-1.44 0-.794.646-1.439 1.44-1.439.793-.001 1.44.645 1.44 1.439Z',
  },
  {
    label: 'LinkedIn',
    href: 'https://www.linkedin.com/company/agenciasus/',
    path: 'M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433a2.062 2.062 0 0 1-2.063-2.065 2.063 2.063 0 1 1 2.063 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z',
  },
  {
    label: 'YouTube',
    href: 'https://www.youtube.com/@agenciasus',
    path: 'M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z',
  },
];

const BrandFooterColumn = () => {
  const Image = config.getComponent('Image').component;

  return (
    <div className="ag-footer__col ag-footer__brand">
      <Link
        to="/"
        className="ag-footer__brand-link"
        aria-label="Página inicial da AgSUS"
      >
        <Image src={logoWhite} alt="AgSUS" className="ag-footer__logo" />
      </Link>
      <p className="ag-footer__social-title">Redes sociais</p>
      <nav className="ag-footer__social" aria-label="Redes sociais oficiais">
        {SOCIAL.map((item) => (
          <a
            key={item.label}
            href={item.href}
            aria-label={item.label}
            title={item.label}
            target="_blank"
            rel="noopener noreferrer"
          >
            <svg viewBox="0 0 24 24" aria-hidden="true">
              {item.circles ? (
                <>
                  <circle cx="5.33" cy="12" r="5.33" />
                  <circle cx="18.67" cy="12" r="5.33" />
                </>
              ) : (
                <path d={item.path} />
              )}
            </svg>
          </a>
        ))}
      </nav>
    </div>
  );
};

// Colunas usadas enquanto /configuracao/footer não traz nenhum Document
// publicado (pasta ausente, vazia ou fora do ar)
const ColunasPadrao = () => (
  <>
    <nav className="ag-footer__col" aria-label="Links institucionais">
      <ul className="ag-footer__list">
        <li>
          <Link to="/institucional">Institucional</Link>
        </li>
        <li>
          <Link to="/institucional/conselhos">Conselho</Link>
        </li>
        <li>
          <Link to="/institucional/diretoria-executiva">
            Diretoria Executiva
          </Link>
        </li>
        <li>
          <Link to="/noticias">Notícias</Link>
        </li>
        <li>
          <Link to="/trabalhe-na-agsus">Trabalhe Conosco</Link>
        </li>
      </ul>
    </nav>

    <nav className="ag-footer__col" aria-label="Links de transparência">
      <ul className="ag-footer__list">
        <li>
          <Link to="/transparencia">Transparência</Link>
        </li>
        <li>
          <Link to="/ouvidoria">Ouvidoria</Link>
        </li>
        <li>
          <Link to="/transparencia/prestacao-de-contas">
            Prestação de Contas
          </Link>
        </li>
        <li>
          <Link to="/areas-de-atuacao/atencao-primaria/mais-medicos">
            Programa Médicos pelo Brasil
          </Link>
        </li>
        <li>
          <Link to="/ouvidoria">Contato</Link>
        </li>
      </ul>
    </nav>

    <address className="ag-footer__col ag-footer__contact">
      <strong>Sede Administrativa</strong>
      <span className="ag-footer__contact-line ag-footer__contact-line--phone">
        (61) 3386-4144
      </span>
      <span className="ag-footer__contact-line ag-footer__contact-line--pin">
        SHN - Quadra 1, Bloco E,
        <br />
        Conj A, 2º andar
        <br />
        Brasília - DF
        <br />
        CEP: 70.701-050
      </span>

      <strong>Escritório Regional de Boa Vista</strong>
      <span className="ag-footer__contact-line ag-footer__contact-line--pin">
        Rua Castelo Branco, 452 -
        <br />
        Calunga Boa Vista - RR
        <br />
        CEP: 69301-270
      </span>
    </address>
  </>
);

// o título do Document só identifica a coluna na pasta
const BLOCOS_OCULTOS = new Set(['title', 'description']);

const ColunaEditavel = ({ doc }) => {
  const blocks = doc.blocks || {};
  const items = (doc.blocks_layout?.items || []).filter(
    (id) => !BLOCOS_OCULTOS.has(blocks[id]?.['@type']),
  );
  return (
    <div className="ag-footer__col ag-footer__col--editavel">
      <RenderBlocks content={{ ...doc, blocks, blocks_layout: { items } }} />
    </div>
  );
};

const Footer = () => {
  const dispatch = useDispatch();
  const rodape = useSelector(
    (state) => state.search?.subrequests?.[RODAPE_SUBREQUEST],
  );
  const colunas = rodape?.items || [];
  const editavel = colunas.length > 0;

  // o servidor já traz as colunas (rodapeAsyncPropExtender); o navegador só
  // busca quando a página chegou sem elas
  useEffect(() => {
    if (!rodape) {
      dispatch(buscaRodape());
    }
  }, [dispatch, rodape]);

  return (
    <footer className="footer ag-footer" id="footer" role="contentinfo">
      <div className="ag-footer__inner">
        <div
          className={`ag-footer__cols${editavel ? ' ag-footer__cols--editavel' : ''}`}
          style={
            editavel ? { '--ag-footer-colunas': colunas.length } : undefined
          }
        >
          <BrandFooterColumn />
          {editavel ? (
            colunas.map((doc) => <ColunaEditavel key={doc['@id']} doc={doc} />)
          ) : (
            <ColunasPadrao />
          )}
        </div>
        <div className="ag-footer__base">
          <button
            type="button"
            className="ag-footer__cookies"
            onClick={() => window.dispatchEvent(new Event(GERENCIAR_COOKIES))}
          >
            Gerenciar Cookies
          </button>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
